export default "__VITE_ASSET__BwWhxvyo__"